import type { ReactNode } from 'react'
import { Download } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@quebon/ui/components/button'
import { useLmsPrintPdfCapability } from '@/hooks/useLmsPrint'

export function openLmsPrintPdfPreview(href: string) {
  const url = new URL(href, window.location.href)
  if (url.origin !== window.location.origin || !url.pathname.startsWith('/admin/')) return
  url.searchParams.set('downloadPdf', '1')
  window.open(url.href, '_blank', 'noopener,noreferrer')
}

interface Props {
  href?: string
  /** Owns all preparation and navigation when supplied (for locks/unsaved-edit guards). */
  onClick?: () => void | Promise<void>
  disabled?: boolean
  className?: string
  children?: ReactNode
}

export function LmsPrintPreviewPdfButton({ href, onClick, disabled, className, children }: Props) {
  const { t } = useTranslation('common')
  const capability = useLmsPrintPdfCapability()
  if (!capability.isSuccess || capability.data?.enabled !== true || !capability.data.assetBaseUrl) return null
  return (
    <Button
      variant="outline"
      className={className}
      disabled={disabled}
      onClick={() => {
        if (onClick) void onClick()
        else if (href) openLmsPrintPdfPreview(href)
      }}
    >
      <Download data-icon="inline-start" />
      {children ?? t('printPdf.download')}
    </Button>
  )
}
